export default "__VITE_ASSET__aZfvTx0O__"